export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "AI provider lub model nie został skonfigurowany": "",
        "AI:": "",
        "Anuluj": "",
        "Błąd parsowania strumienia": "",
        "Błąd podczas tworzenia embedding": "",
        "Błąd serwisu AI:": "",
        "Błąd:": "",
        "Brak dostępnych konwersacji.": "",
        "Brak lub nieprawidłowy tekst": "",
        "Brak nazwy celu raportu PDF.": "",
        "Brak uprawnień": "",
        "Brak wiadomości": "",
        "Brak wymaganych danych celu raportu": "",
        "Chat": "",
        "Chat AI": "",
        "Cześć, jestem Edito Bot. W czym mogę Ci pomóc?": "",
        "Czy na pewno chcesz usunąć tę konwersację?": "",
        "Czy na pewno chcesz usunąć tę wiadomość?": "",
        "dni temu": "",
        "Domyślny": "",
        "Dziękujemy za podzielenie się opinią": "",
        "Edytuj i wyślij ponownie": "",
        "Edytuj wiadomość": "",
        "Generuj raport PDF (osoba)": "",
        "Generuj raport PDF (zespół)": "",
        "Generuję raport PDF...": "",
        "godz. temu": "",
        "Imię i nazwisko": "",
        "Konfiguracja ai": "",
        "Konwersacja": "",
        "Konwersacje z raportami": "",
        "Kopiuj": "",
        "Kto ukończył szkolenia": "",
        "Lista osób z ukończonymi szkoleniami w zespole": "",
        "min temu": "",
        "Model do odpowiedzi": "",
        "Model embedding": "",
        "Model embedding nie istnieje lub nie jest aktywny na Twoim Azure OpenAI.": "",
        "Moje zespoły": "",
        "Najniższy postęp w zespole": "",
        "Nazwa konwersacji": "",
        "Nazwa zespołu": "",
        "Nie można znaleźć odpowiedniego modelu embedding": "",
        "Nie można znaleźć odpowiedniego modelu text": "",
        "Nie otrzymano treści od asystenta.": "",
        "Nie pomocna": "",
        "Nie udało się przetworzyć odpowiedzi AI dla raportu": "",
        "Nie udało się wygenerować treści AI, raport zostanie utworzony bez nich.": "",
        "Nie znaleziono użytkownika o podanym imieniu i nazwisku.": "",
        "Nie znaleziono zespołów do wygenerowania raportu.": "",
        "Nie znaleziono zespołu o podanej nazwie.": "",
        "Nie związana": "",
        "Nieprawidłowe żądanie: Brak message w treści żądania.": "",
        "Nieprawidłowe żądanie: Brak sessionId w treści żądania.": "",
        "Nieznany typ wykresu": "",
        "Nowa": "",
        "Nowa konwersacja": "",
        "Nowa konwersacja z raportami": "",
        "Podaj nową nazwę...": "",
        "Podsumowanie postępów wszystkich moich zespołów": "",
        "Podsumowanie szkoleń zespołu": "",
        "Podsumowanie użytkowników zespołu": "",
        "Podsumowanie zespołu": "",
        "Pokaż osoby z najniższym postępem": "",
        "Pokaż zespoły, którymi zarządzam": "",
        "Pomocna": "",
        "Porównaj moje zespoły i ułóż ranking": "",
        "Postępy moich zespołów": "",
        "Przejdź do konfiguracji, aby włączyć": "",
        "Przygotuj podsumowanie szkoleń dla zespołu": "",
        "Przygotuj raport o użytkowniku po imieniu i nazwisku": "",
        "Ranking moich zespołów": "",
        "Raport PDF został pobrany.": "",
        "Raport użytkownika": "",
        "Rozpocznij nową, klikając przycisk poniżej.": "",
        "System": "",
        "Szczegółowy postęp i jednostki szkoleń": "",
        "Szczegółowy raport użytkownika": "",
        "Średni postęp i liczba ukończonych szkoleń per osoba": "",
        "Ta odpowiedź jest pomocna": "",
        "Ta odpowiedź jest powiązana": "",
        "Ta odpowiedź nie jest pomocna": "",
        "teraz": "",
        "Ty:": "",
        "Unikalne szkolenia zespołu z realizacją i średnim postępem": "",
        "Ustawienia modeli": "",
        "Ustawienia modeli AI": "",
        "Usuń": "",
        "Usuń konwersację": "",
        "Użytkownik": "",
        "wczoraj": "",
        "Wpisz wiadomość...": "",
        "Wprowadź treść wiadomości...": "",
        "Wybierz konwersację, aby rozpocząć": "",
        "Wybierz lub utwórz konwersację": "",
        "Wybierz model do czatu": "",
        "Wybierz model embedding": "",
        "Wybróbuj możliwości chatu AI": "",
        "Wygeneruj raport PDF dla wskazanego zespołu": "",
        "Wygeneruj raport PDF dla wskazanej osoby": "",
        "Wygeneruj wykres postępów zespołu": "",
        "Wykres postępów zespołu": "",
        "Wystąpił błąd serwera podczas streamingu. Spróbuj ponownie później.": "",
        "Wystąpił nieoczekiwany błąd.": "",
        "Wystąpił problem z pobraniem wiadomości.": "",
        "Wyślij": "",
        "Wyślij ponownie": "",
        "Wyślij wiadomość": "",
        "Zadaj pytanie": "",
        "Zapisz": "",
        "Zapisz i wyślij ponownie": "",
        "Zmień nazwę": "",
        "Zmień nazwę konwersacji": ""
    }
};
